import { Link } from "react-router-dom";

interface Props {
  workCount: number;
  reviewCount: number;
  pickCount: number;
}

export default function SiteIntro({ workCount, reviewCount, pickCount }: Props) {
  const stats = [
    { label: "收录作品", value: workCount, icon: "ri-film-line" },
    { label: "影评短摘", value: reviewCount, icon: "ri-chat-quote-line" },
    { label: "编辑专题", value: pickCount, icon: "ri-bookmark-line" },
  ];

  return (
    <section className="rounded-lg border border-background-200 bg-background-100/60 overflow-hidden">
      <div className="grid grid-cols-1 lg:grid-cols-3">
        <div className="lg:col-span-2 p-6 md:p-8">
          <span className="inline-block px-2.5 py-1 rounded-md bg-primary-100 text-primary-800 text-xs font-medium mb-4">
            关于「韩国伦理」
          </span>
          <h2 className="font-heading font-bold text-xl md:text-2xl text-foreground-950">
            一个专注于韩国伦理影视的内容专题平台
          </h2>
          <p className="mt-4 text-sm md:text-base text-foreground-700 leading-relaxed">
            我们聚焦韩国伦理电影与伦理题材电视剧，为喜爱这类作品的成年观众、影评爱好者提供结构清晰的剧情介绍、深度影评与编辑专题推荐。无论是想快速了解一部作品的背景，还是顺着主题进行系统探索，「韩国伦理」都希望成为你可靠的内容索引。
          </p>
          <p className="mt-3 text-sm md:text-base text-foreground-700 leading-relaxed">
            你可以通过分类筛选、关键词搜索快速定位感兴趣的作品，并把喜欢的影视作品收藏到本地列表，随时回来查看。站内所有作品信息与评分均为演示内容。
          </p>
          <div className="mt-6 flex flex-wrap gap-3">
            <Link
              to="/category/erotic"
              className="px-5 h-10 inline-flex items-center gap-2 rounded-md bg-primary-500 text-background-50 text-sm font-medium hover:bg-primary-600 transition-colors"
            >
              <i className="ri-movie-2-line" /> 浏览伦理电影
            </Link>
            <Link
              to="/category/drama"
              className="px-5 h-10 inline-flex items-center gap-2 rounded-md border border-primary-300 text-primary-700 text-sm font-medium hover:bg-primary-100 transition-colors"
            >
              <i className="ri-tv-2-line" /> 浏览伦理电视剧
            </Link>
          </div>
        </div>
        <div className="p-6 md:p-8 bg-primary-900 text-background-50 flex flex-col justify-center gap-4">
          {stats.map((stat) => (
            <div key={stat.label} className="flex items-center gap-4">
              <span className="w-11 h-11 flex items-center justify-center rounded-md bg-background-50/10 text-accent-400">
                <i className={`${stat.icon} text-xl`} />
              </span>
              <div>
                <p className="font-heading font-bold text-2xl">{stat.value}</p>
                <p className="text-xs text-background-50/70">{stat.label}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}